import React from "react";
import PageHeader from "../components/PageHeader";
import Contact from "../components/Contact";

export default function ContactPage() {
  return (
    <div data-testid="page-kontakt">
      <PageHeader
        eyebrow="Kontakt"
        title={
          <>
            Porozmawiajmy o{" "}
            <span className="gold-gradient-text italic">Twojej firmie</span>
          </>
        }
        subtitle="Napisz mi kilka zdań o sytuacji — odezwę się w ciągu 24 godzin i umówimy bezpłatną, krótką rozmowę. Bez zobowiązań, bez ukrytych kosztów."
      />
      <Contact />
    </div>
  );
}
